import React from "react";
import hpBox from "../img/hp_box_1-min.jpg";
import hpBox1 from "../img/hp_box_2-min.jpg";
import hpBox2 from "../img/hp_box_3-min.jpg";
import hpBox3 from "../img/hp_box_4-min.jpg";

const boxes = {
    title: {
        en: "From Captain Candy’s board",
        ka: "კაპიტანი Candy-ის ბორტიდან",
    },
    en: [
        {
            img: hpBox,
            title: <React.Fragment>Can you smell the sweetness in the air?</React.Fragment>,
            description: "Temptation at its best. Discover this world of sweets with us.",
            link: "More information",
            href: "/products",
            longer: true,
        },
        {
            img: hpBox1,
            title: <React.Fragment>All the places we anchor</React.Fragment>,
            description: "You can now find us in four places in Prague!",
            link: "More information",
            href: "/stores"
        },
        {
            img: hpBox2,
            title: <React.Fragment>The end of sour looks!</React.Fragment>,
            description: "Do people give you sour looks? Try offering them our sour jelly beans!",
            link: "More information",
            href: "/products",
            longer: true,
        },
        {
            img: hpBox3,
            title: <React.Fragment>Find out more about what we do</React.Fragment>,
            description: "Discover the journey of a Czech company that brings joy from all over the world.",
            link: "More information",
            href: "/about"
        },
    ],
    ka: [
        {
            img: hpBox,
            title: <React.Fragment>გრძნობ ტკბილ სურნელს ჰაერში?</React.Fragment>,
            description: "ეს ნამდვილი ცდუნებაა! შემოგვიერთდი და აღმოაჩინე ტკბილეულის საოცარი სამყარო.",
            link: "გაიგე მეტი",
            href: "/products",
            longer: true,
        },
        {
            img: hpBox1,
            title: <React.Fragment>ყველა ადგილი, სადაც ჩვენი გემი ჩერდება</React.Fragment>,
            description: "პრაღაში ახლა უკვე ოთხ ადგილას შეგიძლიათ გვესტუმროთ!",
            link: "გაიგე მეტი",
            href: "/stores"
        },
        {
            img: hpBox2,
            title: <React.Fragment>მჟავე სახეების დასასრული!</React.Fragment>,
            description: "ხშირად გიყურებენ მჟავე გამომეტყველებით? შესთავაზე ჩვენი მჟავე ჟელიბონები და ყველაფერი შეიცვლება!",
            link: "გაიგე მეტი",
            href: "/products",
            longer: true,
        },
        {
            img: hpBox3,
            title: <React.Fragment>გაიგე მეტი ჩვენი საქმიანობის შესახებ</React.Fragment>,
            description: "აღმოაჩინე ჩეხური კომპანიის მოგზაურობა, რომელიც მთელი მსოფლიოდან ტკბილ სიხარულს გვიზიარებს.",
            link: "გაიგე მეტი",
            href: "/about"
        },
    ],
};

const HpMapData = {
    en: {
        title: "Our stores in Georgia",
        button: {
            name: "More information",
        }
    },
    ka: {
        title: "ჩვენი მაღაზიები საქართველოში",
        button: {
            name: "მეტი ინფორმაცია",
        }
    }
};
    
export { boxes, HpMapData };
    